<template>
  <div class="box add-contact">
    <div class="inner">
      <h3>{{ $t('view.component.contacts.form.addToSavedNumbers') }}</h3>
      <form @submit.prevent="submit" class="form-wrapper no-margin no-padding with-loading" v-form:form novalidate>
        <div class="loading" v-if="isLoading">
          <Loader />
        </div>
        <div class="form-row">
          <div class="input-wrapper">
            <input type="text"
                   inputmode="tel"
                   autocorrect="off"
                   autocomplete="off"
                   spellcheck="false"
                   :disabled="isCheckPhoneInProgress"
                   required
                   phone
                   v-model.trim="formData.msisdn"
                   @keyup="checkPhone()"
                   @paste="checkPhoneOnPaste($event)"
                   id="msisdn"
                   name="msisdn" />
            <label for="msisdn">{{ $t('view.component.contacts.form.labelNumber') }}</label>
            <Loader v-if="isCheckPhoneInProgress" />
          </div>
          <p class="error-field" v-if="isErrorForField('msisdn')" v-html="getFieldErrorText('msisdn')"></p>
          <p class="error-field" v-if="isCheckPhoneError" v-html="$t('view.component.contacts.form.errorPhoneCheck')"></p>
          <p class="error-field" v-if="!isPhoneUnique" v-html="$t('view.component.contacts.form.errorPhoneNotUnique')"></p>
        </div>
        <div class="form-row">
          <div class="input-wrapper">
            <input type="text"
                   autocorrect="off"
                   autocomplete="off"
                   spellcheck="false"
                   required
                   v-model.trim="formData.description"
                   id="description"
                   name="description" />
            <label for="description">{{ $t('view.component.contacts.form.labelName') }}</label>
          </div>
          <p class="error-field" v-if="isErrorForField('description')" v-html="getFieldErrorText('description')"></p>
        </div>
        <div class="form-row">
          <button type="submit" class="secondary inverted">
            {{ $t('view.component.contacts.form.saveButton') }}
          </button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import FormMixin from '@/orange/mixins/form.mixin'
import ContactsMixin from '@/orange/mixins/contacts.mixin'
import Loader from '@/orange/components/Loader'
import { mapActions, mapMutations } from 'vuex'
import { Notifier, NOTIFY_TYPE } from '@/common/class/notify.class'

export default {
  name: 'ContactsFormAdd',
  mixins: [FormMixin, ContactsMixin],
  components: { Loader },
  methods: {
    ...mapMutations([
      'RESET_CONTACTS'
    ]),
    ...mapActions([
      'addContact',
      'getContacts'
    ]),
    resetForm () {
      this.formData.msisdn = null
      this.formData.description = null
      this.form.resetForm()
      this.RESET_CONTACTS()
      this.getContacts()
    },
    submit () {
      this.showProcessError = false
      if (this.form.invalid || this.isPhoneError) {
        return
      }
      this.SET_CONTACTS_FORM_NAME(this.formData.description)
      this.addContact()
        .then(() => {
          Notifier.show({
            text: this.$t('view.component.contacts.form.contactAddProcessSuccess'),
            type: NOTIFY_TYPE.success
          })
        })
        .catch(() => {
          Notifier.show({
            text: this.$t('view.component.contacts.form.contactAddProcessError'),
            type: NOTIFY_TYPE.error
          })
        })
        .finally(() => {
          this.resetForm()
        })
    }
  }
}
</script>

<style lang="scss" src="../../assets/scss/components/_phone-list.scss" scoped></style>
